// Code snippet copied from : https://github.com/mui/material-ui/blob/v5.15.2/docs/data/material/getting-started/templates/sign-in-side/SignInSide.js and modified the code according to me

import * as React from "react";
import { CssBaseline, TextField, Box, Snackbar } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthContext } from "../contexts/AuthContext";
import styles from "../styles/authentication.module.css";
import MuiAlert from "@mui/material/Alert";

const defaultTheme = createTheme({
    palette: {
        primary: {
            main: "#4f46e5",
        },
    },
});

export default function Authenticate() {
    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [name, setName] = React.useState("");
    const [error, setError] = React.useState("");
    const [message, setMessage] = React.useState("");

    const [formState, setFormState] = React.useState(0);
    const [open, setOpen] = React.useState(false);

    const { handleRegister, handleLogin } = React.useContext(AuthContext);

    const switchForm = (state) => {
        setFormState(state);
        setError("");
    };

    let handleAuth = async () => {
        if (formState === 0 && (!username.trim() || !password.trim())) {
            setError("Username and password are required");
            return;
        }

        if (
            formState === 1 &&
            (!name.trim() || !username.trim() || !password.trim())
        ) {
            setError("Full name, Username and Password are required");
            return;
        }
        try {
            if (formState === 0) {
                await handleLogin(username, password);
                setMessage("Login successful");
                setOpen(true);
            }
            if (formState === 1) {
                let result = await handleRegister(name, username, password);
                console.log(result);
                setUsername("");
                setMessage(result);
                setOpen(true);
                setError("");
                setFormState(0);
                setPassword("");
            }
        } catch (err) {
            let message = err.response.data.message;
            setError(message);
        }
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <div className={styles.authContainer}>
                <CssBaseline />
                <div className={`${styles.logoSide} ${styles.authLeft}`}>
                    <img src="/login.png" alt="" />
                </div>

                <div className={`${styles.authSide} ${styles.authRight}`}>
                    <Box className={styles.authForm}>
                        <div className={styles.authAvatar}>
                            <img src="/auth.png" alt="user avatar" />
                        </div>

                        <div className={styles.authToggle}>
                            <button
                                className={`${styles.authToggleBtn} ${
                                    formState === 0 ? `${styles.active}` : ""
                                }`}
                                onClick={() => switchForm(0)}
                            >
                                Sign In
                            </button>
                            <button
                                className={`${styles.authToggleBtn} ${
                                    formState === 1 ? `${styles.active}` : ""
                                }`}
                                onClick={() => switchForm(1)}
                            >
                                Sign Up
                            </button>
                        </div>
                        <Box
                            className={styles.authTabs}
                            component="form"
                            noValidate
                            sx={{ mt: 1 }}
                        >
                            {formState === 1 ? (
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="fullName"
                                    label="Full Name"
                                    name="fullname"
                                    autoComplete="username"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            ) : (
                                <></>
                            )}

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label="Username"
                                name="username"
                                autoComplete="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                value={password}
                                autoComplete="current-password"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <p className={styles.authError}>{error}</p>
                            <button
                                type="button"
                                className={styles.authSubmitBtn}
                                onClick={handleAuth}
                            >
                                {formState === 0 ? "Sign In" : "Sign Up"}
                            </button>
                        </Box>
                    </Box>
                </div>
            </div>

            <Snackbar
                open={open}
                autoHideDuration={4000}
                message={message}
                onClose={() => setOpen(false)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
            >
                <MuiAlert
                    onClose={() => setOpen(false)}
                    severity="success"
                    elevation={6}
                    variant="filled"
                    sx={{ fontWeight: 500 }}
                >
                    {message}
                </MuiAlert>
            </Snackbar>
        </ThemeProvider>
    );
}
